// extracted by mini-css-extract-plugin
export default {"imageSwiper":"Jzq2RUtR5exSFQklJbpV","cardImageSwiper":"ZiuAat8419h6caMPiXIW","image":"k215yDBg_lKUGnUyDs9Z"};